export default __webpack_public_path__ + "static/media/savingsDebited.1f26fc19.svg";